import { render, staticRenderFns } from "./VideoTag.vue?vue&type=template&id=da981d2e&"
import script from "./VideoTag.vue?vue&type=script&lang=js&"
export * from "./VideoTag.vue?vue&type=script&lang=js&"
import style0 from "./VideoTag.vue?vue&type=style&index=0&id=da981d2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports